export const tickerItems: string[] = [
  "文娱分区新增 3 条现场动态，讨论量正在上升",
  "「社媒热议」昨晚刷新 12 条新留言，前排占座中",
  "本地话题更新 6 条一手视角材料，欢迎补充",
  "线索区收到一条待核实的私信材料，已打上待复盘标",
  "本周现场复盘投票开启，点击参与吃瓜围观",
];

export const heroTicker: string[] = [
  "更新条 · 常驻首页，新料第一时间上墙",
  "私信投稿直达，匿名称呼可自选",
  "关注频道即可对接后续进展",
];

export interface QuickLink {
  icon: string;
  label: string;
  hint: string;
  type: string;
}

export const quickLinks: QuickLink[] = [
  { icon: "ri-chat-heart-line", label: "私信投线索", hint: "一手材料私信直达", type: "primary" },
  { icon: "ri-megaphone-line", label: "公开投稿", hint: "写清时间地点，帖子公开进分区", type: "secondary" },
  { icon: "ri-user-follow-line", label: "关注对接", hint: "关注后跟进进展与后续讨论", type: "accent" },
];

export interface RankItem {
  rank: number;
  title: string;
  tag: string;
  heat: number;
  delta: string;
}

export const hotRanks: RankItem[] = [
  { rank: 1, title: "演唱会散场，应援与票务的那点事", tag: "文娱", heat: 98.7, delta: "↑ 12" },
  { rank: 2, title: "新一线城市的深夜加班群像", tag: "生活", heat: 96.1, delta: "↑ 8" },
  { rank: 3, title: "楼下奶茶店为何永远在排队", tag: "本地", heat: 94.3, delta: "— 0" },
  { rank: 4, title: "地铁里的一场即兴辩论", tag: "社媒", heat: 91.8, delta: "↑ 5" },
  { rank: 5, title: "把周末过成周五的人在想什么", tag: "生活", heat: 89.0, delta: "↓ 2" },
];

export interface Featured {
  tag: string;
  title: string;
  desc: string;
  meta: string;
  img: string;
}

export const featured: Featured = {
  tag: "本周置顶 · 现场复盘",
  title: "一条私信如何长成一场公开讨论",
  desc: "从匿名私信到分区置顶，再到评论区各执一词：我们拆解一条线索在社区里的完整生命周期，围观一条动态是怎样一路被顶上来的。",
  meta: "参与讨论 68 · 32 条跟帖 · 复盘进行中",
  img: "https://readdy.ai/api/search-image?query=crowded%20concert%20arena%20at%20night%20with%20warm%20red%20and%20amber%20stage%20spotlights%20hitting%20a%20sea%20of%20raised%20phones%20and%20hands%2C%20cinematic%20editorial%20press%20photography%2C%20soft%20atmospheric%20haze%2C%20high%20energy%20but%20tastefully%20framed%2C%20rich%20warm%20tones%2C%20clean%20composition&width=1280&height=820&seq=feature-recap-v1&orientation=landscape",
};

export interface Board {
  title: string;
  desc: string;
  stat: string;
  tag: string;
  size: "big" | "small";
  img: string;
}

export const boards: Board[] = [
  {
    title: "文娱动态",
    desc: "票务、演出、片场与散场背后的讨论现场。一手视角、应援实况与幕后盘点都先到这报到。",
    stat: "动态 128 · 热度 98.7",
    tag: "分区现场",
    size: "big",
    img: "https://readdy.ai/api/search-image?query=editorial%20magazine%20collage%20of%20concert%20ticket%20stubs%20playbill%20backstage%20passes%20and%20stage%20lights%20over%20cream%20paper%2C%20warm%20deep%20red%20and%20amber%20palette%2C%20flat%20lay%20press%20art%20style%2C%20soft%20shadows%2C%20high%20detail%2C%20cohesive%20warm%20tones&width=1100&height=760&seq=board-wenyu-v1&orientation=landscape",
  },
  {
    title: "社媒热议",
    desc: "截图怎么传、原帖怎么看，一屏吃明白跨平台的讨论风向。",
    stat: "留言 96 · 上升中",
    tag: "吃瓜现场",
    size: "small",
    img: "https://readdy.ai/api/search-image?query=overhead%20flat%20lay%20of%20a%20smartphone%20screen%20showing%20social%20comment%20threads%20next%20to%20printed%20chat%20bubbles%20on%20a%20warm%20amber%20desk%2C%20editorial%20photography%2C%20cozy%20evening%20lighting%2C%20clean%20and%20tasteful%2C%20red%20and%20cream%20color%20story&width=780&height=560&seq=board-shemei-v1&orientation=portrait",
  },
  {
    title: "一线现场",
    desc: "街头与现场的第一视角材料，谁在场、谁先说。",
    stat: "动态 72 · 待核实 3",
    tag: "一手材料",
    size: "small",
    img: "https://readdy.ai/api/search-image?query=night%20city%20street%20scene%20with%20warm%20street%20lamps%20and%20amber%20signage%20glow%2C%20first%20person%20observer%20vantage%20point%2C%20editorial%20reportage%20photography%2C%20soft%20grain%2C%20cinematic%20red%20and%20gold%20tones%2C%20atmospheric%20but%20tasteful&width=780&height=560&seq=board-yixian-v1&orientation=portrait",
  },
  {
    title: "生活话题",
    desc: "城市生活里的共同槽点与暖点，通勤、排队与深夜档。",
    stat: "跟帖 154 · 讨论热",
    tag: "一起聊",
    size: "small",
    img: "https://readdy.ai/api/search-image?query=cozy%20urban%20life%20still%20life%20with%20takeaway%20coffee%20commute%20card%20and%20warm%20indoor%20lights%20on%20a%20cream%20table%2C%20editorial%20lifestyle%20photography%2C%20warm%20amber%20and%20soft%20red%20accents%2C%20clean%20minimal%20composition%2C%20high%20detail&width=780&height=560&seq=board-shenghuo-v1&orientation=portrait",
  },
];

export interface Talk {
  handle: string;
  text: string;
  agree: number;
  replies: number;
  time: string;
  tag: string;
  pinned?: boolean;
}

export const talks: Talk[] = [
  { handle: "吃瓜不迷路", text: "散场之后大家其实都在等一个靠谱的复盘，这帖把时间线捋明白了，先蹲。", agree: 128, replies: 34, time: "12 分钟前", tag: "文娱", pinned: true },
  { handle: "现场君", text: "本人就在现场，票是正规渠道买的，只聊聊散场通勤体验，这块有实图可发。", agree: 96, replies: 21, time: "31 分钟前", tag: "一线现场" },
  { handle: "前排小板凳", text: "截图得看原帖评论区，跨平台转来转去最容易断章取义，理性吃瓜。", agree: 74, replies: 12, time: "1 小时前", tag: "社媒热议" },
  { handle: "线索通", text: "这类一手材料建议先私信打码再公开，避免误伤，管理员可以帮忙核。", agree: 63, replies: 8, time: "2 小时前", tag: "线索" },
];

export const navLinks = [
  { label: "实时热榜", href: "#hot" },
  { label: "分区现场", href: "#boards" },
  { label: "热议圈", href: "#talk" },
  { label: "关注对接", href: "#follow" },
];